import axios from 'axios'


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
	baseURL: "http://wx.lyjxsg.com/wechat",
	timeout: 10000
	//http://192.168.2.26:6165
	//https://srdrjbz.cn:7170
})
// request拦截器
service.interceptors.request.use(function (config) {
	// 发送请求的相关逻辑
	// config:对象  与 axios.defaults 相当
	// 借助config配置token

	// 判断token存在再做配置
	let a = sessionStorage.getItem('token')
	const isToken = (config.headers || {}).isToken === false
	config.headers['loginType'] = "admin"
	if (a && !isToken) {
		config.headers['token'] = sessionStorage.getItem('token') // 让每个请求携带自定义token 请根据实际情况自行修改
	}
	// get请求映射params参数
	if (config.method === 'get' && config.params) {
		let url = config.url + '?';
		for (const propName of Object.keys(config.params)) {
			const value = config.params[propName];
			var part = encodeURIComponent(propName) + "=";
			if (value !== null && typeof (value) !== "undefined") {
				if (typeof value === 'object') {
					for (const key of Object.keys(value)) {
						if (value[key] !== null && typeof (value[key]) !== 'undefined') {
							let params = propName + '[' + key + ']';
							let subPart = encodeURIComponent(params) + '=';
							url += subPart + encodeURIComponent(value[key]) + '&';
						}
					}
				} else {
					url += part + encodeURIComponent(value) + "&";
				}
			}
		}
		url = url.slice(0, -1);

		config.params = {};
		config.url = url;
	}

	return config
}, error => {
	console.log(error)
	Promise.reject(error)
})




export default service
